/**
 * Reducer for refresh schedules
 */
import { reducerFor } from '../common/redux-crud-reducers'

export default reducerFor('schedules', null)
